<template>
  <v-container class="d-flex justify-center align-center" fill-height>
    <v-card class="pa-4" max-width="800">
      <v-card-text>
        <v-form ref="loginForm" v-model="isFormValid">
          <v-text-field
            v-model="email"
            label="Email"
            type="email"
            :rules="emailRules"
            required
            style="min-width: 320px"
          />

          <v-text-field
            v-model="password"
            label="Password"
            :type="showPassword ? 'text' : 'password'"
            :rules="passwordRules"
            required
            autocomplete="current-password"
            :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append-inner="showPassword = !showPassword"
          />


          <v-alert v-if="errorMessage" type="error" dismissible class="mt-2">
            {{ errorMessage }}
          </v-alert>

          <v-btn :disabled="!isFormValid" color="primary" block class="mt-4" @click="onSubmit">
            Login
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';

const router = useRouter();

const email = ref('');
const password = ref('');
const isFormValid = ref(false);
const errorMessage = ref('');
const showPassword = ref(false);


const emailRules = [
  (v) => !!v || 'Email is required.',
  (v) => /.+@.+\..+/.test(v) || 'Must be a valid email.',
];

const passwordRules = [
  (v) => !!v || 'Password is required.',
  (v) => (v && v.length >= 4) || 'Password must be at least 4 characters.',
];

async function onSubmit() {
  errorMessage.value = '';

  const data = `username=${encodeURIComponent(email.value)}&password=${encodeURIComponent(
    password.value,
  )}&remember-me=true&submit=Login`;
  try {
    await axios.post('/api/authentication', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  } catch (e) {
    if (e.response?.status === 401) {
      errorMessage.value = 'Invalid email or password.';
    } else {
      errorMessage.value = 'Unexpected error';
      console.error('Unexpected login error: ', e);
    }
    return;
  }
  await router.push('/');
}
</script>

<style scoped>
/* Add custom styling if needed */
</style>
